<div class="flex flex-col p-6">

    <!-- HEADER -->
    <div class="mb-6">
        <h3 class="text-xl font-semibold text-gray-800">
            {{ serviceData ? 'Edit Service' : 'Create Service' }}
        </h3>
        <p class="text-sm text-gray-500 mt-1">
            {{ serviceData ? 'Update the details below.' : 'Fill in the details to create a new service offering.' }}
        </p>
    </div>

    <!-- FORM -->
    <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-4">

        <div class="grid grid-cols-2 gap-4">
            <!-- NAME -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Name <span class="text-red-500">*</span></label>
                <input type="text" formControlName="name" placeholder="e.g. Oil Change" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
            </div>

            <!-- SLUG -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Slug <span class="text-red-500">*</span></label>
                <input type="text" formControlName="slug" placeholder="e.g. oil-change" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
            </div>

            <!-- CATEGORY -->
            <div class="col-span-2">
                <label class="block text-sm font-medium text-gray-700 mb-1">Category <span class="text-red-500">*</span></label>
                <input type="text" formControlName="category" placeholder="e.g. Maintenance" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
            </div>
        </div>

        <!-- DESCRIPTION -->
        <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <textarea rows="3" formControlName="description" placeholder="Service details..." class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none resize-none"></textarea>
        </div>

        <div class="grid grid-cols-2 gap-4">
            <!-- BASE PRICE -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Base Price ($) <span class="text-red-500">*</span></label>
                <input type="number" formControlName="base_price" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
            </div>

            <!-- DURATION -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Duration (mins) <span class="text-red-500">*</span></label>
                <input type="number" formControlName="estimated_duration_minutes" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
            </div>
        </div>

        <!-- IS ACTIVE -->
        <div class="flex items-center gap-2 mt-2">
            <input type="checkbox" formControlName="is_active" id="isActive" class="w-4 h-4 text-blue-600 rounded focus:ring-blue-500" />
            <label for="isActive" class="text-sm font-medium text-gray-700">Active (Visible to users)</label>
        </div>

        <!-- FOOTER -->
        <div class="flex justify-end gap-3 pt-6 border-t mt-6">
            <button type="button" (click)="cancel.emit()" class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition">
                Cancel
            </button>
            <button type="submit" [disabled]="form.invalid" class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 transition">
                {{ serviceData ? 'Update Service' : 'Create Service' }}
            </button>
        </div>

    </form>

</div>
